// src/pages/SignInPage.js
import React, { useState } from 'react';
import { useAuth } from '../auth/AuthProvider';
import fhiLogo from '../assets/fhi-logo-white.png';

export default function SignInPage() {
  const { signIn, error } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleSignIn = async () => {
    setLoading(true);
    try {
      await signIn();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-center">
      <div style={{ width: '100%', maxWidth: 480, textAlign: 'center' }}>

        <div style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          background: 'var(--navy)', borderRadius: 'var(--radius-lg)',
          padding: '1rem 1.75rem', marginBottom: '1.5rem'
        }}>
          <img src={fhiLogo} alt="FHI" style={{ height: 40, width: 'auto', display: 'block' }} />
        </div>

        <h1 style={{ marginBottom: '.5rem' }}>Lead Pay Portal</h1>
        <p style={{ color: 'var(--gray-600)', marginBottom: '2rem', fontSize: '.95rem' }}>
          Sign in with your work account to continue.
        </p>

        <div className="card" style={{ padding: '2rem' }}>
          <button
            className="btn btn-primary btn-lg"
            onClick={handleSignIn}
            disabled={loading}
            style={{ width: '100%', justifyContent: 'center' }}
          >
            {loading ? 'Redirecting…' : '🔐 Sign in with Microsoft'}
          </button>

          {error && (
            <div className="alert alert-error" style={{ marginTop: '1rem', textAlign: 'left' }}>
              {error}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}